
import { useNavigate, useParams } from "react-router-dom";
import { Section } from "../components/styled/Containers.style";
import { PageTitle, TextDefault } from "../components/styled/Text.style";
import { Vspace } from '../components/styled/Separators.style'
import { composeUrl } from "../utils/utils";
import { PATHS } from "../routes/CaiExperienceRouter";
import PageContainerCmp from "./PageContainerCmp";
import FotoOtherUsefulInfo from "../components/foto-other-useful-info/FotoOtherUsefulInfo";

/* istanbul ignore next */
const Trct_FotoOtherUsefulInfoPage = () => {
    let navigate = useNavigate();
    let { token } = useParams();

    const goToNextStepHandler = () => {
        navigate(composeUrl(token, PATHS.CAI_PREVIEW))
    }

    return (
        <>
            <PageContainerCmp
                nextStepHandler={goToNextStepHandler}
                routePath={PATHS.TRCT_FOTO_OTHER_USEFUL_INFO}
            >
                <>
                    <Section>
                        <PageTitle>Foto di altri documenti utili</PageTitle>
                        <Vspace></Vspace>
                        <TextDefault centered>Qualora disponibili, scatta le foto degli ulteriori documenti relativi al sinistro (in particolare puoi caricare: <strong>Documento di identità del testimone, Dichiarazione del testimone, verbale scambio generalità,</strong> ecc...)</TextDefault>
                    </Section>

                    <FotoOtherUsefulInfo />
                </>
            </PageContainerCmp>
        </>

    )
}

export default Trct_FotoOtherUsefulInfoPage